import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
var _createReducer;
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import { createReducer, createAction } from 'redux-act';
import { createSelector } from 'reselect';
import { createResource } from '@gandi/redux-resource';
import { selectCurrentId } from '@gandi/redux-sharing';
import { selectRaw as selectRawState, selectSharingIdProp } from './utils';
var formatInfosAPIReturn = function formatInfosAPIReturn(data) {
  return {
    outstandingAmount: data.outstanding_amount,
    annualBalance: data.annual_balance,
    monthlyInvoicingMode: Boolean(data.prepaid_monthly_invoice),
    grid: data.grid
  };
};

// $FlowFixMe[signature-verification-failure]
export var mergeInfos = createAction('[redux-billing][infos] Merge infos');
export var resource = createResource('billing.billing.infos');
export var selectIsFetching = function selectIsFetching(state, _ref) {
  var sharingId = _ref.sharingId;
  return resource.selectIsFetchingOne(state, sharingId);
};
export var selectIsLoaded = function selectIsLoaded(state, _ref2) {
  var sharingId = _ref2.sharingId;
  return resource.selectIsLoadedOne(state, sharingId);
};
export var selectIsFailure = function selectIsFailure(state, _ref3) {
  var sharingId = _ref3.sharingId;
  return resource.selectIsFailureOne(state, sharingId);
};
export var selectIsToRefetch = function selectIsToRefetch(state, _ref4) {
  var sharingId = _ref4.sharingId;
  return resource.selectIsToRefetchOne(state, sharingId);
};
export var selectShouldFetch = function selectShouldFetch(state, _ref5) {
  var sharingId = _ref5.sharingId;
  return resource.selectShouldFetchOne(state, sharingId);
};
export var selectIsPatching = function selectIsPatching(state, _ref6) {
  var sharingId = _ref6.sharingId;
  return resource.selectIsPatchingOne(state, sharingId);
};
export var selectRaw = createSelector([selectRawState], function (raw) {
  return raw.infos;
});
var getInfos = function getInfos(raw, sharingId) {
  return raw[sharingId];
};
export var selectInfos = createSelector([selectRaw, selectSharingIdProp], getInfos);
export var selectInfosForCurrent = createSelector([selectRaw, selectCurrentId], getInfos);
var getGrid = function getGrid() {
  var infos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return infos.grid || 'A';
};
export var selectGrid = createSelector([selectInfos, selectSharingIdProp], getGrid);
export var selectGridForCurrent = createSelector([selectInfosForCurrent], getGrid);
var getMonthlyInvoicingMode = function getMonthlyInvoicingMode(infos) {
  return infos && infos.monthlyInvoicingMode;
};
export var selectMonthlyInvoicingMode = createSelector([selectInfos, selectSharingIdProp], getMonthlyInvoicingMode);
export var selectMonthlyInvoicingModeForCurrent = createSelector([selectInfosForCurrent], getMonthlyInvoicingMode);
export var fetchInfos = function fetchInfos() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState) {
    var currentId = selectCurrentId(getState());
    var sharingId = options.sharingId || currentId;
    // eslint-disable-next-line global-require
    var invalidateMeans = require('./means').invalidateMeans;
    if (typeof sharingId !== 'string') {
      return _Promise.reject(new Error('[billing.infos] `fetchInfos` called without `sharingId` option' + ' nor @gandi/redux-sharing dep/state.'));
    }
    return dispatch(resource.fetchOne("/billing/infos/".concat(sharingId), _objectSpread(_objectSpread({}, options), {}, {
      label: sharingId,
      params: options.params || {},
      on200: function on200(response) {
        // Always invalidate payment means after having fetched billing infos of a given sharing id.
        dispatch(invalidateMeans({
          sharingId: sharingId
        }));
        return response;
      },
      not200: function not200(response) {
        return _Promise.reject(response);
      }
    })));
  };
};

/*
 * Updating billing-infos has only one use-case at the moment:
 * - setting a new value for monthly invoicing mode.
 */

export var patchInfos = function patchInfos(params) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState) {
    var currentId = selectCurrentId(getState());
    var sharingId = options.sharingId || currentId;
    if (typeof sharingId !== 'string') {
      return _Promise.reject(new Error('[billing.infos] `patchInfos` called without `sharingId` option' + ' nor @gandi/redux-sharing dep/state.'));
    }
    var optimistic = params.optimistic || false;
    var body = {
      prepaid_monthly_invoice: params.monthlyInvoicingMode
    };
    var previousMonthlyInvoicingMode = selectMonthlyInvoicingMode(getState(), {
      sharingId: sharingId
    });
    if (optimistic) {
      dispatch(mergeInfos({
        body: {
          monthlyInvoicingMode: params.monthlyInvoicingMode
        },
        sharingId: sharingId
      }));
    }
    return dispatch(resource.patchOne("/billing/infos/".concat(sharingId), body, _objectSpread(_objectSpread({}, options), {}, {
      label: sharingId,
      params: options.params || {},
      on200: function on200(response) {
        return response;
      },
      not200: function not200(response) {
        return _Promise.reject(response);
      }
    }))).catch(function (err) {
      if (optimistic) {
        dispatch(mergeInfos({
          body: {
            monthlyInvoicingMode: previousMonthlyInvoicingMode
          },
          sharingId: sharingId
        }));
      }
      throw err;
    });
  };
};

// $FlowFixMe[signature-verification-failure]
var reducer = createReducer((_createReducer = {}, _defineProperty(_createReducer, resource.fetchOne.success.getType(), function (state, _ref7) {
  var data = _ref7.response.data,
    sharingId = _ref7.label;
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, sharingId, formatInfosAPIReturn(data)));
}), _defineProperty(_createReducer, mergeInfos, function (state, _ref8) {
  var body = _ref8.body,
    sharingId = _ref8.sharingId;
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, sharingId, _objectSpread(_objectSpread({}, state[sharingId] || {}), body)));
}), _createReducer), {});
export default reducer;